import { createFileRoute } from '@tanstack/react-router';
import { TripsListScreen } from '@/features/trips/TripsListScreen.tsx';

export const Route = createFileRoute('/_app/trips/')({ component: TripsListScreen });
